// extracted by mini-css-extract-plugin
module.exports = {"root":"_b33a09","small":"_c80747","medium":"_034950","large":"_53df76","iconRating":"_97a034","average":"_e14109","compact":"_646277"};